import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import HeaderDenise from "./components/Header/HeaderDenise.jsx"
import Home from "./components/Home/Home.jsx"
import About from "./components/About/About.jsx"
import Registrations from "./components/Registrations/Registrations.jsx"
import Contact from "./components/Contact/Contact.jsx"
import Gallery from "./components/Gallery/Gallery.jsx"
import PrivateInstruction from "./components/PrivateInstruction/PrivateInstruction.jsx"
import NoPageFound from "./components/NoPageFound/NoPageFound.jsx"

function App() {
  console.log('Starting')
  console.log(process.env.REACT_APP_TEST)
  return (
    <div className="App">
      <BrowserRouter>
        <HeaderDenise />
        <Routes>
          <Route index element={<Home />}/>
          <Route path="/home" element={<Home />}/>
          <Route path="/about" element={<About />}/>
          <Route path="/about-us" element={<About />}/>
          <Route path="/registration" element={<Registrations />}/>
          <Route path="/registrations" element={<Registrations />}/>
          <Route path="/contact" element={<Contact title={"Contact"} />}/>
          <Route path="/contact-us" element={<Contact />}/>
          <Route path="/gallery" element={<Gallery />}/>
          <Route path="/photos" element={<Gallery />}/>
          <Route path="/photo-gallery" element={<Gallery />}/>
          <Route path="/private-instruction" element={<PrivateInstruction />}/>
          <Route path="*" element={<NoPageFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
